import { render } from "./Facturacion.vue?vue&type=template&id=8188f422&scoped=true"
import script from "./Facturacion.vue?vue&type=script&lang=js"
export * from "./Facturacion.vue?vue&type=script&lang=js"

import "./Facturacion.vue?vue&type=style&index=0&id=8188f422&scoped=true&lang=css"

import exportComponent from "D:\\GIT\\Interfaz_Colecturia\\colecturia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8188f422"]])

export default __exports__